export default __webpack_public_path__ + "static/media/1-1.cd3b6b1f.webp";